import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  AccordionBody,
  AccordionItem,
  Form,
  Label,
  FormGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardHeader,
  Accordion,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  Alert,
} from "reactstrap"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useLocation, useNavigate } from "react-router-dom"
import { withTranslation } from "react-i18next"
import moment from "moment"
import {
  addTracker,
  getTrackersTableData,
  importTrackers,
  updateMultipleTrackers,
} from "helpers/backend_helper"
import TrackerDrawer from "./TrackerDrawer"
import * as Yup from "yup"
import { useFormik } from "formik"
import {
  dateFormatter,
  defaultPageSizeOptions,
  downloadExcel,
  numberSorter,
  showToast,
  stringSorter,
  getOperatorByIccid,
  operatorFormatter,
  searchToURL,
  booleanSorter,
  orSeparator,
} from "utils/general"
import {
  Table as AntdTable,
  Input as AntdInput,
  Select,
  Form as AntdForm,
  InputNumber,
} from "antd"
import { tableDefaultHeight } from "constants/layout"
import { clientLinksFormatter } from "utils/tables"
import ReactApexChart from "react-apexcharts"
const { Search, TextArea } = AntdInput

const TrackerConfigs = props => {
  const [trackers, setTrackers] = useState([])
  const [filteredTrackers, setFilteredTrackers] = useState([])
  const [activeTab, setActiveTab] = useState("1")
  const [addModal, setAddModal] = useState(false)
  const [importModal, setImportModal] = useState(false)
  const [settingsModal, setSettingsModal] = useState(false)
  const [filtersOpen, setFiltersOpen] = useState("")
  const [alertsOpen, setAlertsOpen] = useState("")
  const [ongoingSearch, setOngoingSearch] = useState(false)
  const [ongoingAdd, setOngoingAdd] = useState(false)
  const [ongoingImport, setOngoingImport] = useState(false)
  const [ongoingAction, setOngoingAction] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [showDrawer, setShowDrawer] = useState(false)
  const [linkedFilter, setLinkedFilter] = useState()
  const [typeFilter, setTypeFilter] = useState([])
  const [statusFilter, setStatusFilter] = useState([])
  const [operatorFilter, setOperatorFilter] = useState([])
  const [simStatusFilter, setSimStatusFilter] = useState([])
  const [searchText, setSearchText] = useState("")

  const [statistics, setStatistics] = useState({ total: 0 })
  const [modelStats, setModelStats] = useState([])
  const [modelLabels, setModelLabels] = useState([])

  const [multilinks, setMultilinks] = useState([])
  const [duplicates, setDuplicates] = useState([])
  const [menu, setMenu] = useState(false) //Dropdown button state
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [title] = useState(props.t("Trackers"))

  const search = useLocation().search
  const navigate = useNavigate()
  const location = useLocation()

  const abortRef = useRef(null)
  useEffect(() => {
    document.title = title + " | Suvanto Care"

    const searchParam = new URLSearchParams(search).get("search")
    if (searchParam && searchParam != "null") setSearchText(searchParam.trim())

    abortRef.current = new AbortController()
    getTrackers()
    return () => abortRef.current.abort()
  }, [])

  // Clear selection when closing drawer
  useEffect(() => {
    if (!showDrawer) setSelectedRow(null)
  }, [showDrawer])

  // Reset settings form when modal closed
  useEffect(() => {
    if (!settingsModal) settingsValidation.resetForm()
  }, [settingsModal])

  // Check duplicate values
  useEffect(() => {
    if (trackers) {
      // GSM, IMSI, SERIAL, IMEI
      let dups = []
      for (let i = 0; i < trackers.length - 1; i++) {
        for (let j = i + 1; j < trackers.length; j++) {
          if (trackers[i].serial && trackers[i].serial === trackers[j].serial) {
            dups.push({
              key: trackers[i].serial,
              name: "SN:" + trackers[i].serial,
            })
          }
          if (trackers[i].gsm && trackers[i].gsm === trackers[j].gsm) {
            dups.push({ key: trackers[i].gsm, name: "GSM:" + trackers[i].gsm })
          }
          if (trackers[i].imei && trackers[i].imei === trackers[j].imei) {
            dups.push({
              key: trackers[i].imei,
              name: "IMEI:" + trackers[i].imei,
            })
          }
          if (trackers[i].imsi && trackers[i].imsi === trackers[j].imsi) {
            dups.push({
              key: trackers[i].imsi,
              name: "IMSI:" + trackers[i].imsi,
            })
          }
          if (trackers[i].iccid && trackers[i].iccid === trackers[j].iccid) {
            dups.push({
              key: trackers[i].iccid,
              name: "ICCID:" + trackers[i].iccid,
            })
          }
        }
      }
      setDuplicates(dups)
    }
  }, [trackers])

  // Calculate stats
  useEffect(() => {
    let temp = new Object()
    temp.total = trackers.length
    temp.linked = trackers.filter(data => data.links.length > 0).length
    temp.minifinder = trackers.filter(data => data.type == "MiniFinder").length
    temp.farnear = trackers.filter(data => data.type == "Farnear").length
    temp.minifinderGprs = trackers.filter(
      data => data.type == "MiniFinderGPRS"
    ).length
    temp.yepzon = trackers.filter(data => data.type == "Yepzon").length
    temp.navigil = trackers.filter(data => data.type == "Navigil").length
    temp.undefinedType = trackers.filter(
      data => data.type == "" || !data.type
    ).length
    setStatistics(temp)

    let otherModels =
      temp.total -
      temp.minifinder -
      temp.minifinderGprs -
      temp.navigil -
      temp.yepzon -
      temp.farnear

    // Model stats
    setModelStats([
      temp.farnear,
      temp.minifinder,
      temp.minifinderGprs,
      temp.navigil,
      temp.yepzon,
      otherModels,
    ])
    setModelLabels([
      "Farnear",
      "MiniFinder",
      "MiniFinderGPRS",
      "Navigil",
      "Yepzon",
      props.t("Other"),
    ])
  }, [trackers])

  // Check multiple links
  useEffect(() => {
    if (trackers) {
      let multis = []
      for (const element of trackers) {
        if (element.links.length > 1) {
          multis.push({ key: element.key, name: element.name })
        }
      }
      setMultilinks(multis)
    }
  }, [trackers])

  // Hide alerts if no content
  useEffect(() => {
    if (multilinks.length == 0 && duplicates.length == 0) setAlertsOpen("")
  }, [multilinks, duplicates])

  // Search or filter changed
  useEffect(() => {
    handleSearch()
  }, [
    searchText,
    trackers,
    statusFilter,
    typeFilter,
    operatorFilter,
    simStatusFilter,
    linkedFilter,
  ])

  // Handle search function
  const handleSearch = () => {
    let searchTextLowercase = searchText.toLowerCase()
    const terms = searchTextLowercase
      .split(orSeparator)
      .map(p => p.trim())
      .filter(Boolean)

    let result = trackers.filter(data => {
      const textMatch =
        terms.length == 0
          ? true
          : terms.some(
            t =>
              data.gsm?.toLowerCase().includes(t) ||
              data.imei?.toLowerCase().includes(t) ||
              data.name?.toLowerCase().includes(t) ||
              data.imsi?.toLowerCase().includes(t) ||
              data.iccid?.toLowerCase().includes(t) ||
              data.operator?.toLowerCase().includes(t) ||
              data.serial?.toLowerCase().includes(t) ||
              data.key?.toLowerCase() === t ||
              data.linkedNames?.toLowerCase().includes(t) ||
              data.batch?.toLowerCase().includes(t) ||
              data.firmware?.toLowerCase().includes(t) ||
              data.serverNumber?.toLowerCase().includes(t) ||
              data.groupTags?.toLowerCase().includes(t) ||
              data.orderNumber?.toLowerCase().includes(t)
          )

      return (
        (statusFilter?.length == 0 || statusFilter?.includes(data.status)) &&
        (typeFilter?.length == 0 || typeFilter?.includes(data.type)) &&
        (operatorFilter?.length == 0 ||
          operatorFilter?.includes(data.operator)) &&
        (simStatusFilter?.length == 0 ||
          simStatusFilter?.includes(data.simStatus?.toLowerCase())) &&
        (!linkedFilter ||
          (linkedFilter === "1" && data.links.length > 0) ||
          (linkedFilter === "2" && data.links.length == 0)) &&
        textMatch
      )
    })
    setFilteredTrackers(result)
  }

  // Get trackers
  const getTrackers = () => {
    setOngoingSearch(true)
    getTrackersTableData(abortRef.current)
      .then(result => {
        //console.log("care: ", result.entries)
        if (result.statusCode === 200 && result.entries != null) {
          result.entries.sort((a, b) => (a.name > b.name ? 1 : -1))
          let now = moment()
          for (const element of result.entries) {
            element.linkedNames = getLinkedNames(element.links)

            if (element.statusTime) {
              element.lastConnectedDiff = now.diff(
                moment(element.statusTime),
                "hours"
              )
            } else {
              element.lastConnectedDiff = 99999
            }

            element.operator = getOperatorByIccid(element.iccid) || ""
          }
          setTrackers(result.entries)

          // Update selected row
          if (selectedRow?.key) {
            let foundRow = result.entries.find(
              item => item.key == selectedRow.key
            )
            setSelectedRow(foundRow)
          }
        } else {
          setTrackers([])
        }
        setOngoingSearch(false)
      })
      .catch(err => {
        console.log(err)
        setTrackers([])
        setOngoingSearch(false)
      })
  }

  // Get linked names in proper format
  const getLinkedNames = links => {
    let linkedNames = []
    if (links) {
      for (const link of links) {
        linkedNames.push(link.name)
      }
    }
    return linkedNames.join()
  }

  // Create validation
  const createValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      type: "MiniFinder",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(props.t("Required field")),
    }),
    onSubmit: values => {
      console.log("Submit: ", values)
      setOngoingAdd(true)
      addTracker(abortRef.current, values.type, values.name)
        .then(result => {
          if (result.statusCode == 200) {
            //console.log(result)
            showToast(props.t("Success"), "success")
            createValidation.resetForm()
            setAddModal(false)
            getTrackers()
          } else {
            console.log(result)
            showToast(props.t("Error"), "error")
          }
          setOngoingAdd(false)
        })
        .catch(err => {
          console.log(err)
          showToast(props.t("Error"), "error")
          setOngoingAdd(false)
        })
    },
  })

  // Import validation
  const importValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firmware: "",
      batch: "",
      json: "",
      serverNumber: "",
    },
    validationSchema: Yup.object({
      json: Yup.string().required(props.t("Required field")),
    }),
    onSubmit: values => {
      console.log("Submit: ", values)
      setOngoingImport(true)
      importTrackers(
        abortRef.current,
        values.json,
        values.batch,
        values.firmware,
        values.serverNumber
      )
        .then(result => {
          if (result.statusCode == 200) {
            //console.log(result)
            showToast(props.t("Success"), "success")
            importValidation.resetForm()
            setImportModal(false)
            getTrackers()
          } else {
            console.log(result)
            showToast(props.t("Error"), "error")
          }
        })
        .catch(err => {
          console.log(err)
          showToast(props.t("Error"), "error")
        })
        .finally(() => {
          setOngoingImport(false)
        })
    },
  })

  // Settings validation
  const settingsValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      statusCheckHour: null,
      statusCheckInterval: null,
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      if (!ongoingAction) {
        setOngoingAction(true)
        updateMultipleTrackers(
          abortRef.current,
          selectedRowKeys,
          values
        )
          .then(result => {
            if (result.statusCode == 200) {
              //console.log(result)
              showToast(props.t("Success"), "success")
              setSettingsModal(false)
              getTrackers()
            } else {
              console.log(result)
              showToast(props.t("Error"), "error")
            }
          })
          .catch(err => {
            console.log(err)
            showToast(props.t("Error"), "error")
          })
          .finally(() => {
            setOngoingAction(false)
          })
      }
    },
  })

  // Table structure
  const columns = [
    {
      dataIndex: "actions",
      title: props.t("Actions"),
      align: "center",
      sorter: (a, b, sortOrder) => {
        return booleanSorter(a, b, "hasRemarks", sortOrder)
      },
      render: editFormatter,
      fixed: "left",
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "statusTime",
      title: props.t("Status updated"),
      sorter: (a, b) => {
        return a.statusTime - b.statusTime
      },
      render: (cell, row) => {
        return row.lastConnectedDiff == null || row.lastConnectedDiff > 120 ? (
          <span className="text-danger">{dateFormatter(cell)}</span>
        ) : (
          dateFormatter(cell)
        )
      },
      width: "160px",
      ellipsis: true,
    },
    {
      dataIndex: "status",
      title: props.t("Status"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "status", sortOrder)
      },
      render: cell => {
        return cell == "off" ? (
          <span className="text-danger">{cell}</span>
        ) : (
          cell
        )
      },
      width: "100px",
      ellipsis: true,
    },
    {
      dataIndex: "battery",
      title: props.t("Battery"),
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["battery"], b["battery"], sortOrder)
      },
      width: "110px",
      ellipsis: true,
    },
    {
      dataIndex: "name",
      title: props.t("Name"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "name", sortOrder)
      },
      fixed: "left",
      width: "175px",
      ellipsis: true,
    },
    {
      dataIndex: "type",
      title: props.t("Device type"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "type", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "orderNumber",
      title: props.t("Order number"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "orderNumber", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "groupTags",
      title: props.t("Tags"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "groupTags", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "linkedNames",
      title: props.t("Links"),
      render: clientLinksFormatter,
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "linkedNames", sortOrder)
      },
      width: "400px",
      ellipsis: true,
    },
    {
      dataIndex: "gsm",
      title: props.t("GSM"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "gsm", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "imei",
      title: props.t("IMEI"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "imei", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "imsi",
      title: props.t("IMSI"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "imsi", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "iccid",
      title: props.t("ICCID"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "iccid", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "operator",
      title: props.t("Operator"),
      render: (text, record) => {
        return operatorFormatter(record.operator)
      },
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "operator", sortOrder)
      },
      width: "110px",
      ellipsis: true,
      align: "center",
    },
    {
      dataIndex: "serial",
      title: props.t("Serial"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "serial", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "trackerId",
      title: props.t("Device ID"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "trackerId", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "batch",
      title: props.t("Batch"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "batch", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "firmware",
      title: props.t("Firmware"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "firmware", sortOrder)
      },
      width: "120px",
      ellipsis: true,
    },
    {
      dataIndex: "serverNumber",
      title: props.t("Server number"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "serverNumber", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "simStatus",
      title: props.t("SIM status"),
      sorter: (a, b, sortOrder) => {
        return stringSorter(a, b, "simStatus", sortOrder)
      },
      width: "140px",
      ellipsis: true,
    },
    {
      dataIndex: "statusCheckInterval",
      title: props.t("Status query interval"),
      render: cell => {
        return cell ? (
          <span>{cell + "h"}</span>
        ) : (
          <></>
        )
      },
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["statusCheckInterval"], b["statusCheckInterval"], sortOrder)
      },
      width: "180px",
      ellipsis: true,
    },
    {
      dataIndex: "statusCheckHour",
      title: props.t("Daily status query"),
      render: cell => {
        return cell ? (
          <span>{cell + ":00"}</span>
        ) : (
          <></>
        )
      },
      sorter: (a, b, sortOrder) => {
        return numberSorter(a["statusCheckHour"], b["statusCheckHour"], sortOrder)
      },
      width: "160px",
      ellipsis: true,
    },
    {
      dataIndex: "key",
      title: props.t("GUID"),
      sorter: (a, b) => {
        return stringSorter(a, b, "key")
      },
      width: "120px",
      ellipsis: true,
    },
    //AntdTable.SELECTION_COLUMN,
  ]

  function editFormatter(cell, row) {
    return (
      <>
        <Button
          color="primary"
          outline
          size="sm"
          onClick={() => {
            setShowDrawer(true)
            setSelectedRow(row)
          }}
        >
          <i className="mdi mdi-pencil" />
          {row.hasRemarks && (
            <i className="mdi mdi-alert-circle text-danger ms-1" />
          )}
        </Button>
      </>
    )
  }

  // Export values
  const generateExcel = () => {
    const heading = [
      [
        props.t("Status updated"),
        props.t("Status"),
        props.t("Battery"),
        props.t("Name"),
        props.t("Device type"),
        props.t("Order number"),
        props.t("Tags"),
        props.t("Links"),
        props.t("GSM"),
        props.t("IMEI"),
        props.t("IMSI"),
        props.t("ICCID"),
        props.t("Operator"),
        props.t("Serial"),
        props.t("Device ID"),
        props.t("Batch"),
        props.t("Firmware"),
        props.t("Server number"),
        props.t("SIM status"),
        props.t("GUID"),
      ],
    ]
    const data = filteredTrackers.map(elt => [
      dateFormatter(elt.statusTime),
      elt.status,
      elt.battery,
      elt.name,
      elt.type,
      elt.orderNumber,
      elt.groupTags,
      elt.linkedNames,
      elt.gsm,
      elt.imei,
      elt.imsi,
      elt.iccid,
      elt.operator,
      elt.serial,
      elt.trackerId,
      elt.batch,
      elt.firmware,
      elt.serverNumber,
      elt.simStatus,
      elt.key,
    ])

    downloadExcel(title, heading, data)
    showToast(props.t("Excel file exported succesfully!"), "success")
  }

  // Table selection changed
  const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys)
  }

  // Donut chart options for device models
  const modelOptions = {
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      theme: "dark",
      style: {
        fontSize: "14px",
        fontFamily: undefined,
      },
    },
    id: "models-donut",
    labels: modelLabels,
    // https://htmlcolorcodes.com/color-chart/
    colors: [
      "#F1948A", // red
      "#BB8FCE", // violet
      "#85C1E9", // blue
      "#76d7c4", // blueish green
      "#7DCEA0", // green
      "#F8C471", // yellow
      "#e59866", // orange
      "#BFC9CA", // grey
    ],
    legend: {
      show: true,
      position: "right",
      itemMargin: {
        vertical: 6,
      },
    },
    dataLabels: {
      enabled: true,
      textAnchor: "middle",
      distributed: false,
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: "12px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: "400",
        colors: [
          "#00000063",
          "#00000063",
          "#00000063",
          "#00000063",
          "#00000063",
          "#00000063",
        ],
      },
      background: {
        enabled: true,
        foreColor: "#fff",
        padding: 3,
        borderRadius: 2,
        borderWidth: 0,
        borderColor: "#fff",
        opacity: 0.9,
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: "#000",
          opacity: 0.45,
        },
      },
    },
  }

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title={props.t("Trackers")} />
          <Card>
            <CardHeader className="bg-transparent border-bottom">
              <div className="d-flex flex-wrap">
                <ul className="nav nav-tabs nav-tabs-custom card-header-tabs">
                  <NavItem>
                    <NavLink
                      to="#"
                      active={activeTab === "1"}
                      onClick={() => {
                        setActiveTab("1")
                      }}
                    >
                      {props.t("Table")}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      active={activeTab === "2"}
                      onClick={() => {
                        setActiveTab("2")
                      }}
                    >
                      {props.t("Statistics")}
                    </NavLink>
                  </NavItem>
                </ul>
              </div>
            </CardHeader>
            <CardBody>
              <TabContent activeTab={activeTab}>
                <TabPane className="show" tabId="1">
                  <Accordion
                    flush
                    open={alertsOpen}
                    toggle={id => {
                      id === alertsOpen ? setAlertsOpen("") : setAlertsOpen(id)
                    }}
                  >
                    <AccordionItem>
                      <AccordionBody
                        accordionId="1"
                        className="accordion-zeropadding"
                      >
                        <Alert color="danger">
                          <div>
                            <h5 className="alert-heading">
                              {props.t("Duplicate values")}
                            </h5>
                            {duplicates.map((entry, index) => (
                              <Button
                                size="sm"
                                color="danger"
                                outline
                                key={"" + index}
                                className="me-2 mb-2"
                                onClick={() => {
                                  setSearchText(entry.key)
                                }}
                              >
                                <span>{entry.name}</span>
                              </Button>
                            ))}
                          </div>
                          <div>
                            <h5 className="alert-heading">
                              {props.t("Multiple links")}
                            </h5>
                            {multilinks.map((entry, index) => (
                              <Button
                                size="sm"
                                color="danger"
                                outline
                                key={"" + index}
                                className="me-2 mb-2"
                                onClick={() => {
                                  setSearchText(entry.key)
                                }}
                              >
                                <span>{entry.name}</span>
                              </Button>
                            ))}
                          </div>
                        </Alert>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                  <Row>
                    <Col>
                      {trackers != null && (
                        <React.Fragment>
                          <Row>
                            <Col className="mb-3" style={{ maxWidth: "320px" }}>
                              <Search
                                placeholder={props.t("Search")}
                                allowClear
                                value={searchText}
                                onChange={event => {
                                  setSearchText(event.target.value)
                                }}
                                onBlur={() =>
                                  // Apply search word to URL
                                  searchToURL(searchText, location, navigate)
                                }
                                style={{ minWidth: "240px" }}
                              />
                            </Col>
                            <Col className="col-auto">
                              <Button
                                color="primary"
                                className="compact-button"
                                id="filter-button"
                                outline
                                onClick={() => {
                                  filtersOpen.length > 0
                                    ? setFiltersOpen("")
                                    : setFiltersOpen("1")
                                }}
                              >
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target="filter-button"
                                >
                                  {props.t("Filters")}
                                </UncontrolledTooltip>
                                {filtersOpen ? (
                                  <i className="mdi mdi-filter-minus"></i>
                                ) : (
                                  <i className="mdi mdi-filter-menu"></i>
                                )}
                              </Button>

                              <Button
                                className="compact-button ms-3"
                                color="primary"
                                disabled={ongoingSearch}
                                onClick={() => {
                                  getTrackers()
                                }}
                              >
                                <i className="mdi mdi-refresh me-2" />
                                {props.t("Refresh")}
                              </Button>

                              <Button
                                className="compact-button ms-3"
                                color="primary"
                                disabled={ongoingSearch || selectedRowKeys.length == 0}
                                onClick={() => {
                                  setSettingsModal(true)
                                }}
                              >
                                <i className="mdi mdi-cog me-2" />
                                {props.t("Change settings")}
                              </Button>

                              <Button
                                className="compact-button ms-3"
                                color="success"
                                onClick={() => {
                                  setAddModal(true)
                                }}
                              >
                                <i className="mdi mdi-plus me-2" />
                                {props.t("Create new")}
                              </Button>
                              <Button
                                className="compact-button ms-3"
                                color="success"
                                onClick={() => {
                                  setImportModal(true)
                                }}
                              >
                                <i className="mdi mdi-import me-2" />
                                {props.t("Import")}
                              </Button>
                              {(duplicates.length > 0 ||
                                multilinks.length > 0) && (
                                  <Button
                                    color="danger"
                                    className="round-icon-buttonnn compact-button ms-3"
                                    id="alerts-button"
                                    onClick={() => {
                                      alertsOpen.length > 0
                                        ? setAlertsOpen("")
                                        : setAlertsOpen("1")
                                    }}
                                  >
                                    <UncontrolledTooltip
                                      placement="bottom"
                                      target="alerts-button"
                                    >
                                      {props.t("Notices")}
                                    </UncontrolledTooltip>
                                    {alertsOpen ? (
                                      <i className="mdi mdi-alert-minus"></i>
                                    ) : (
                                      <i className="mdi mdi-alert-plus"></i>
                                    )}
                                  </Button>
                                )}
                              {selectedRowKeys.length > 0 &&
                                <Button
                                  color="danger"
                                  outline
                                  size="sm"
                                  className="ms-3"
                                  onClick={() => {
                                    onSelectChange([], [])
                                  }}
                                >
                                  {props.t("Clear selections")}
                                </Button>
                              }
                            </Col>
                            <Col>
                              <span className="float-end ms-2">
                                <UncontrolledTooltip
                                  placement="bottom"
                                  target="downloadstatstable"
                                >
                                  {props.t("Download statistics")}
                                </UncontrolledTooltip>
                                <Dropdown
                                  id="printButtonServicesStats"
                                  isOpen={menu}
                                  toggle={() => setMenu(!menu)}
                                  className="download-btn text-center"
                                  type="button"
                                >
                                  <DropdownToggle
                                    id="downloadstatstable"
                                    className="text-muted"
                                    tag="i"
                                  >
                                    <i className="mdi mdi-download" />
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={() => generateExcel()}
                                    >
                                      {props.t("Download .xlsx")}
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </span>
                              <div className="mt-2 float-end">
                                <p>
                                  {filteredTrackers.length}{" "}
                                  {props.t("found results")}
                                </p>
                              </div>
                            </Col>
                          </Row>

                          <Accordion
                            flush
                            open={filtersOpen}
                            toggle={id => {
                              id === filtersOpen
                                ? setFiltersOpen("")
                                : setFiltersOpen(id)
                            }}
                          >
                            <AccordionItem>
                              <AccordionBody
                                accordionId="1"
                                className="mb-3"
                                style={{
                                  border: "1px solid",
                                  borderRadius: "4px",
                                }}
                              >
                                <Row className="mb-3">
                                  <Col className="col-auto">
                                    <span
                                      className="font-size-16 text-primary"
                                      style={{ fontWeight: "500" }}
                                    >
                                      <i className="mdi mdi-filter me-1"></i>
                                      {props.t("Filters")}
                                    </span>
                                  </Col>
                                  <Col>
                                    <Button
                                      color="danger"
                                      outline
                                      size="sm"
                                      onClick={() => {
                                        setLinkedFilter()
                                        setTypeFilter([])
                                        setStatusFilter([])
                                        setOperatorFilter([])
                                        setSimStatusFilter([])
                                      }}
                                    >
                                      <i className="mdi mdi-close me-1"></i>
                                      {props.t("Clear")}
                                    </Button>
                                  </Col>
                                </Row>
                                <Row xs={1} sm={2} md={3} xl={4}>
                                  <Col className="mb-3">
                                    <Select
                                      placeholder={props.t("Status")}
                                      mode="multiple"
                                      allowClear
                                      style={{ width: "100%" }}
                                      value={statusFilter}
                                      onChange={v => {
                                        setStatusFilter(v)
                                      }}
                                      options={[
                                        {
                                          value: "idle",
                                          label: props.t("Idle"),
                                        },
                                        {
                                          value: "charging",
                                          label: props.t("Charging"),
                                        },
                                        {
                                          value: "lowbat",
                                          label: props.t("Low battery"),
                                        },
                                        {
                                          value: "off",
                                          label: props.t("Offline"),
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col className="mb-3">
                                    <Select
                                      placeholder={props.t("Device type")}
                                      mode="multiple"
                                      allowClear
                                      style={{ width: "100%" }}
                                      value={typeFilter}
                                      onChange={v => {
                                        setTypeFilter(v)
                                      }}
                                      options={[
                                        { value: "Farnear", label: "Farnear" },
                                        {
                                          value: "MiniFinder",
                                          label: "MiniFinder",
                                        },
                                        {
                                          value: "MiniFinderGPRS",
                                          label: "MiniFinder GPRS",
                                        },
                                        { value: "Navigil", label: "Navigil" },
                                        { value: "Yepzon", label: "Yepzon" },
                                      ]}
                                    />
                                  </Col>
                                  <Col className="mb-3">
                                    <Select
                                      placeholder={props.t("Links")}
                                      allowClear
                                      style={{ width: "100%" }}
                                      value={linkedFilter}
                                      onChange={v => {
                                        setLinkedFilter(v)
                                      }}
                                      options={[
                                        {
                                          value: "1",
                                          label: props.t("Linked"),
                                        },
                                        {
                                          value: "2",
                                          label: props.t("Not linked"),
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col className="mb-3">
                                    <Select
                                      placeholder={props.t("Operator")}
                                      mode="multiple"
                                      allowClear
                                      style={{ width: "100%" }}
                                      value={operatorFilter}
                                      onChange={v => {
                                        setOperatorFilter(v)
                                      }}
                                      options={[
                                        { value: "DNA", label: "DNA" },
                                        { value: "Elisa", label: "Elisa" },
                                        { value: "Telia", label: "Telia" },
                                        {
                                          value: "Telefonica",
                                          label: "Telefonica",
                                        },
                                      ]}
                                    />
                                  </Col>
                                  <Col className="mb-3">
                                    <Select
                                      placeholder={props.t("SIM status")}
                                      mode="multiple"
                                      allowClear
                                      style={{ width: "100%" }}
                                      value={simStatusFilter}
                                      onChange={v => {
                                        setSimStatusFilter(v)
                                      }}
                                      options={[
                                        {
                                          value: "active",
                                          label: props.t("Active"),
                                        },
                                        {
                                          value: "deactivated",
                                          label: props.t("Deactivated"),
                                        },
                                        {
                                          value: "pause",
                                          label: props.t("Paused"),
                                        },
                                        {
                                          value: "terminated",
                                          label: props.t("Terminated"),
                                        },
                                      ]}
                                    />
                                  </Col>
                                </Row>
                              </AccordionBody>
                            </AccordionItem>
                          </Accordion>

                          <Row className="mt-1">
                            <Col xl="12">
                              <AntdTable
                                className="colored-header narrow-header"
                                bordered
                                size="small"
                                rowKey={"key"}
                                columns={columns}
                                dataSource={filteredTrackers}
                                rowSelection={{
                                  //type: "radio",
                                  //fixed: false,
                                  selectedRowKeys: selectedRowKeys,
                                  onChange: onSelectChange,
                                  //columnWidth: 0,
                                  //renderCell: () => "",
                                }}
                                /*onRow={(record, rowIndex) => {
                                  return {
                                    onClick: event => {
                                      if (
                                        selectedRowKeys.includes(record.key)
                                      ) {
                                        setSelectedRowKeys([])
                                      } else {
                                        setSelectedRowKeys([record.key])
                                      }
                                    },
                                  }
                                }}*/
                                pagination={{
                                  showSizeChanger: true,
                                  defaultPageSize: 50,
                                  pageSizeOptions: defaultPageSizeOptions,
                                }}
                                loading={ongoingSearch}
                                tableLayout="auto"
                                scroll={{
                                  x: "max-content",
                                  y: tableDefaultHeight,
                                }}
                              />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </Col>
                  </Row>
                </TabPane>

                <TabPane className="show" tabId="2">
                  <Table
                    style={{ tableLayout: "fixed" }}
                    className="table"
                    bordered={false}
                    striped={false}
                    hover={true}
                  >
                    <thead>
                      <tr>
                        <th></th>
                        <th>{props.t("Count")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">{props.t("Total")}</th>
                        <td>{statistics.total}</td>
                      </tr>
                      <tr>
                        <th scope="row">{props.t("Linked")}</th>
                        <td>{statistics.linked}</td>
                      </tr>
                      <tr>
                        <th scope="row">{props.t("MiniFinder")}</th>
                        <td>{statistics.minifinder}</td>
                      </tr>
                      <tr>
                        <th scope="row">{props.t("Farnear")}</th>
                        <td>{statistics.farnear}</td>
                      </tr>
                      <tr>
                        <th scope="row">{props.t("MiniFinder GPRS")}</th>
                        <td>{statistics.minifinderGprs}</td>
                      </tr>
                      <tr>
                        <th scope="row">{props.t("Navigil")}</th>
                        <td>{statistics.navigil}</td>
                      </tr>
                      <tr>
                        <th scope="row">{props.t("Yepzon")}</th>
                        <td>{statistics.yepzon}</td>
                      </tr>
                      <tr>
                        <th scope="row">{props.t("Undefined type")}</th>
                        <td>{statistics.undefinedType}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <Row className="mt-4" xs={1}>
                    <Col style={{ maxWidth: "700px" }}>
                      <Card>
                        <CardHeader>{props.t("Models")}</CardHeader>
                        <CardBody style={{ height: "300px" }}>
                          <ReactApexChart
                            options={modelOptions}
                            series={modelStats}
                            type="donut"
                            height="100%"
                            className="apex-charts apexcharts-donut"
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>

          <Modal
            isOpen={addModal}
            toggle={() => {
              setAddModal(!addModal)
            }}
            centered
          >
            <ModalHeader>{props.t("Create new")}</ModalHeader>
            <Form
              className="form-horizontal"
              onSubmit={e => {
                e.preventDefault()
                return false
              }}
            >
              <ModalBody>
                <FormGroup>
                  <Label>{props.t("Device type")}</Label>
                  <Select
                    value={createValidation.values.type}
                    placeholder={props.t("Choose")}
                    onChange={v => {
                      createValidation.setFieldValue("type", v)
                    }}
                    options={[
                      { label: props.t("Farnear"), value: "Farnear" },
                      { label: props.t("MiniFinder"), value: "MiniFinder" },
                      {
                        label: props.t("MiniFinderGPRS"),
                        value: "MiniFinderGPRS",
                      },
                      { label: props.t("Navigil"), value: "Navigil" },
                    ]}
                    style={{ width: 100 + "%" }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>{props.t("Description")}</Label>
                  <AntdForm.Item
                    validateStatus={createValidation.errors.name ? "error" : ""}
                    hasFeedback
                    help={createValidation.errors.name}
                  >
                    <AntdInput
                      allowClear
                      placeholder={props.t("Description")}
                      value={createValidation.values.name}
                      onChange={v => {
                        createValidation.setFieldValue("name", v.target.value)
                      }}
                    />
                  </AntdForm.Item>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setAddModal(false)
                  }}
                >
                  {props.t("Cancel")}
                </Button>
                <Button
                  color="success"
                  disabled={ongoingAdd}
                  onClick={() => {
                    createValidation.submitForm()
                  }}
                >
                  {props.t("Add")}
                </Button>{" "}
              </ModalFooter>
            </Form>
          </Modal>

          <Modal
            isOpen={importModal}
            toggle={() => {
              setImportModal(!importModal)
            }}
            centered
          >
            <ModalHeader>{props.t("Import")}</ModalHeader>
            <Form
              className="form-horizontal"
              onSubmit={e => {
                e.preventDefault()
                return false
              }}
            >
              <ModalBody>
                <FormGroup>
                  <Label>{props.t("Batch")}</Label>
                  <AntdInput
                    allowClear
                    placeholder={props.t("2023-01")}
                    value={importValidation.values.batch}
                    onChange={v => {
                      importValidation.setFieldValue("batch", v.target.value)
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>{props.t("Firmware")}</Label>
                  <AntdInput
                    allowClear
                    placeholder={props.t("Firmware")}
                    value={importValidation.values.firmware}
                    onChange={v => {
                      importValidation.setFieldValue("firmware", v.target.value)
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>{props.t("Server number")}</Label>
                  <Select
                    value={importValidation.values.serverNumber}
                    placeholder={props.t("Choose")}
                    onChange={v => {
                      importValidation.setFieldValue("serverNumber", v)
                    }}
                    options={[
                      { label: props.t("Undefined"), value: "" },
                      { label: "31811", value: "31811" },
                      { label: "+3584573950158", value: "+3584573950158" },
                      { label: "+358509020154", value: "+358509020154" },
                      { label: "+61428449770", value: "+61428449770" },
                      { label: "+4759447471", value: "+4759447471" },
                    ]}
                    style={{ width: 100 + "%" }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>{props.t("JSON")}</Label>
                  <AntdForm.Item
                    validateStatus={importValidation.errors.json ? "error" : ""}
                    hasFeedback
                    help={importValidation.errors.json}
                  >
                    <TextArea
                      allowClear
                      rows={8}
                      placeholder={
                        "[{'MSISDN': '358401234567', 'IMEI': '867858039519148', 'IMSI': '238208700975587'}]"
                      }
                      value={importValidation.values.json}
                      onChange={v => {
                        importValidation.setFieldValue("json", v.target.value)
                      }}
                    />
                  </AntdForm.Item>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setImportModal(false)
                  }}
                >
                  {props.t("Cancel")}
                </Button>
                <Button
                  color="success"
                  disabled={ongoingImport}
                  onClick={() => {
                    importValidation.submitForm()
                  }}
                >
                  {props.t("Import")}
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

          {/** Change settings modal */}
          <Modal
            isOpen={settingsModal}
            toggle={() => {
              setSettingsModal(!settingsModal)
            }}
            centered
          >
            <ModalHeader>{props.t("Change settings")}</ModalHeader>
            <Form
              className="form-horizontal"
              onSubmit={e => {
                e.preventDefault()
                return false
              }}
            >
              <ModalBody>
                <div className="mb-3">
                  <span
                    className="me-1 mb-1 badge badge-soft-primary font-size-13"
                  >
                    {selectedRowKeys.length + " " + props.t("selected devices")}
                  </span>
                </div>
                <Row xs={1}>
                  <Col>
                    <FormGroup row className="align-items-center">
                      <Label sm={5}>
                        {props.t("Status query interval")}
                      </Label>
                      <Col sm={7}>
                        <InputNumber
                          value={settingsValidation.values.statusCheckInterval}
                          suffix={props.t("hours")}
                          style={{ width: "100%" }}
                          min={0}
                          max={72}
                          onChange={v => {
                            settingsValidation.setFieldValue(
                              "statusCheckInterval",
                              v
                            )
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup row className="align-items-center">
                      <Label sm={5}>
                        {props.t("Daily status query")}
                      </Label>
                      <Col sm={7}>
                        <Select
                          value={settingsValidation.values.statusCheckHour}
                          placeholder={props.t("Choose")}
                          allowClear
                          onChange={v => {
                            settingsValidation.setFieldValue("statusCheckHour", v)
                          }}
                          options={[
                            { label: props.t("Disable"), value: 0 },
                            { label: "01:00", value: 1 },
                            { label: "02:00", value: 2 },
                            { label: "03:00", value: 3 },
                            { label: "04:00", value: 4 },
                            { label: "05:00", value: 5 },
                            { label: "06:00", value: 6 },
                            { label: "07:00", value: 7 },
                            { label: "08:00", value: 8 },
                            { label: "09:00", value: 9 },
                            { label: "10:00", value: 10 },
                            { label: "11:00", value: 11 },
                            { label: "12:00", value: 12 },
                            { label: "13:00", value: 13 },
                            { label: "14:00", value: 14 },
                            { label: "15:00", value: 15 },
                            { label: "16:00", value: 16 },
                            { label: "17:00", value: 17 },
                            { label: "18:00", value: 18 },
                            { label: "19:00", value: 19 },
                            { label: "20:00", value: 20 },
                            { label: "21:00", value: 21 },
                            { label: "22:00", value: 22 },
                            { label: "23:00", value: 23 },
                            { label: "24:00", value: 24 },
                          ]}
                          style={{ width: 100 + "%" }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    settingsValidation.resetForm()
                  }}
                >
                  {props.t("Reset form")}
                </Button>
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setSettingsModal(false)
                  }}
                >
                  {props.t("Cancel")}
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    settingsValidation.submitForm()
                  }}
                  disabled={selectedRowKeys.length == 0 || ongoingAction}
                >
                  {props.t("Set")}
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

          <TrackerDrawer
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
            selectedRow={selectedRow}
            getTrackers={getTrackers}
            trackers={trackers}
          />
        </Container>
      </div>
    </>
  )
}

TrackerConfigs.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(TrackerConfigs)
